import React from 'react'
import style from "css/address.module.css";
import AddressCard from './addressCard';

function AddressList({ addrList, tagList, deleteAddress, checkBoxHandler, openData }) {
    return (
        <div
            className={style.addrList_container}
            style={{ borderTop: addrList.length > 0 ? "1px solid #b4b4b4" : "none" }}
        >
            {
                addrList.length > 0 &&
                addrList.map((addr, idx) => (
                    <AddressCard
                        key={addr.key}
                        info={addr}
                        tagList={tagList}
                        deleteAddress={deleteAddress}
                        checkBoxHandler={checkBoxHandler}
                        openData={openData}
                        isLastCard={addrList.length === idx + 1}
                    />
                ))
            }
        </div>
    )
}

export default AddressList